import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const AlignCenter = props => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <path d="M25.040 9.917h1c0.55 0 1 0.447 1 1v10c0 0.552-0.45 1-1 1h-20c-0.554 0-1-0.448-1-1v-10c0-0.553 0.446-1 1-1h19zM26.050 24.917c0.524 0 0.95 0.425 0.95 0.95v0.1c0 0.524-0.426 0.95-0.95 0.95h-20.022c-0.524 0-0.95-0.426-0.95-0.95v-0.1c0-0.525 0.426-0.95 0.95-0.95h20.022zM5.95 7c-0.524 0-0.95-0.426-0.95-0.95v-0.1c0-0.524 0.426-0.95 0.95-0.95h20.022c0.524 0 0.95 0.426 0.95 0.95v0.1c0 0.524-0.426 0.95-0.95 0.95h-20.022z" />
  </SvgIcon>
);

export default AlignCenter;
